import React, { useRef, useState, useEffect, ReactNode } from "react";

interface ScrollableContainerProps {
  children: ReactNode; // 스크롤 가능한 내용을 외부에서 받음
}

const HorizontalScrollableContainer: React.FC<ScrollableContainerProps> = ({
  children,
}) => {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [startScrollLeft, setStartScrollLeft] = useState(0);

  const onDragStart = (clientX: number) => {
    if (scrollContainerRef.current) {
      setIsDragging(true);
      setStartX(clientX);
      setStartScrollLeft(scrollContainerRef.current.scrollLeft);
      scrollContainerRef.current.style.transition = "none";
    }
  };

  const onDragMove = (clientX: number) => {
    if (isDragging && scrollContainerRef.current) {
      const deltaX = clientX - startX;
      scrollContainerRef.current.scrollLeft = startScrollLeft - deltaX;
    }
  };

  const onDragEnd = () => {
    setIsDragging(false);
    if (scrollContainerRef.current) {
      scrollContainerRef.current.style.transition = "scroll-left 0.2s ease";
    }
  };

  useEffect(() => {
    if (isDragging) {
      const handleMouseMove = (e: MouseEvent) => onDragMove(e.clientX);
      const handleMouseUp = () => onDragEnd();
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
      return () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };
    }
  }, [isDragging]);

  return (
    <div className="relative w-full max-w-full">
      <div
        ref={scrollContainerRef}
        className="flex space-x-4 overflow-x-scroll p-4 cursor-grab"
        style={{
          overflowX: "auto",
          pointerEvents: "auto",
          scrollbarWidth: "none",
        }}
        onMouseDown={(e) => onDragStart(e.clientX)}
        onTouchStart={(e) => onDragStart(e.touches[0].clientX)}
      >
        {children} {/* 외부에서 넣어준 내용을 그대로 표시 */}
      </div>
    </div>
  );
};

export default HorizontalScrollableContainer;
